import { useMemo } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useSafeRedirect } from './useSafeRedirect';
import PageLoader from '../components/loaders/PageLoader';

export default function PermissionRoute({ children, requiredPermission }) {
  const { isAuthenticated, hasPermission, loading } = useAuth();

  const needsLogin = !loading && !isAuthenticated;
  const needsView = !loading && isAuthenticated && !hasPermission('view');
  const needsPermission = !loading && isAuthenticated && hasPermission('view') && requiredPermission && !hasPermission(requiredPermission);

  const redirectPath = useMemo(() => {
    if (needsLogin || needsView) return '/login';
    if (needsPermission) return '/dashboard';
    return null;
  }, [needsLogin, needsView, needsPermission]);

  useSafeRedirect(redirectPath, !!redirectPath);

  if (loading) {
    return <PageLoader />;
  }

  if (!isAuthenticated || !hasPermission('view') || (requiredPermission && !hasPermission(requiredPermission))) {
    return null;
  }

  return children;
}
